import React, { useState, useEffect, useMemo } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import RightsCheck from "../General/RightsCheck";

const PrintBudgetHeadWise = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [ClosingDebitTotal, setClosingDebitTotal] = useState("");
  const [ClosingCreditTotal, setClosingCreditTotal] = useState("");
  const [BudgetTotal, setBudgetTotal] = useState("");
  const [BalanceTotal, setBalanceTotal] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  const filters = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      fyear:
        urlParams.get("fyear") ||
        localStorage.getItem("DefaultFYear") ||
        "",
      endDate: urlParams.get("endDate") || "",
      accountLevel:
        urlParams.get("accountLevel") ||
        urlParams.get("Accountlevel") ||
        "0",
      showZeroAccounts: urlParams.get("showZeroAccounts") !== "0",
      accountCode: (
        urlParams.get("accountCode") ||
        urlParams.get("AccountCode") ||
        ""
      ).trim(),
      accountName: (
        urlParams.get("accountName") ||
        urlParams.get("AccountName") ||
        ""
      ).trim(),
    };
  }, []);

  useEffect(() => {
    document.title = "Print Budget Head Wise";
    const year = parseInt(filters.fyear, 10);
    if (!year) {
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Accounts/GetBudgetHeadWise",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo: 1,
        pageSize: 10000,
        FYear: year,
        EndDate: filters.endDate,
        AccountLevel: parseInt(filters.accountLevel, 10) || 0,
        ShowZeroAccounts: filters.showZeroAccounts,
        AccountCode: filters.accountCode,
        AccountName: filters.accountName,
        ShowThirdOnly: false,
      },
    })
      .then((response) => {
        if (response.data?.status_code !== 0) {
          setLedger(
            Array.isArray(response.data?.ListofRecords)
              ? response.data.ListofRecords
              : []
          );
          setTotalRecords(response.data?.totalRecords ?? 0);
          setClosingDebitTotal(response.data?.ClosingDebitTotal ?? "");
          setClosingCreditTotal(response.data?.ClosingCreditTotal ?? "");
          setBudgetTotal(response.data?.BudgetTotal ?? "");
          setBalanceTotal(response.data?.BalanceTotal ?? "");
        } else {
          setLedger([]);
          setTotalRecords(0);
        }
      })
      .catch(() => setLedger([]))
      .finally(() => setLoading(false));
  }, [AccessKey, UserID, MemberType, filters]);

  const levelLabel =
    filters.accountLevel === "1"
      ? "1st Level"
      : filters.accountLevel === "2"
      ? "2nd Level"
      : filters.accountLevel === "3"
      ? "3rd Level"
      : "All Levels";

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.Selected_Account.Account_Code}</td>
          <td>{item.Selected_Account.Account_Description}</td>
          <td className="text-end">{item.ClosingDebit}</td>
          <td className="text-end">{item.ClosingCredit}</td>
          <td className="text-end">{item.Budget_Allocation}</td>
          <td className="text-end">{item.Balance}</td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan="7" className="text-center text-muted">
          No Data Found
        </td>
      </tr>
    );
  };

  return (
    <>
      <RightsCheck />
      <Page orientation="landscape" size="a4">
        <table className="table table-sm table-bordered table-print">
          <thead>
            <tr>
              <th colSpan={7}>
                <PrintHeader title="Budget Head Wise" />
              </th>
            </tr>
            <tr>
              <th colSpan={7}>
                Year: {filters.fyear} | Level: {levelLabel} | As on:{" "}
                {filters.endDate || "—"} | Zero utilization:{" "}
                {filters.showZeroAccounts ? "Yes" : "No"} | Records:{" "}
                {totalRecords}
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="text-center">
                  <Spinner animation="border" role="status" />
                </td>
              </tr>
            ) : (
              <>
                <tr>
                  <th>Sr.</th>
                  <th>Account Code</th>
                  <th>Account Name</th>
                  <th className="text-end">Utilized Debit</th>
                  <th className="text-end">Utilized Credit</th>
                  <th className="text-end">Budget</th>
                  <th className="text-end">Balance</th>
                </tr>
                {renderLedger()}
                <tr>
                  <td colSpan="3" className="text-end fw-bold">
                    Total
                  </td>
                  <td className="text-end fw-bold">{ClosingDebitTotal}</td>
                  <td className="text-end fw-bold">{ClosingCreditTotal}</td>
                  <td className="text-end fw-bold">{BudgetTotal}</td>
                  <td className="text-end fw-bold">{BalanceTotal}</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default PrintBudgetHeadWise;
